import {
  SWIPER_DEFAULTS,
  SWIPER_FRACTION,
  SWIPER_2ROWS,
  SWIPER_AUTO,
  SWIPER_ADV,
  SWIPER_NAV,
  SWIPER_ON_PLUS,
  HEADER_SELECTOR,
  EDITION_COOKIE,
  EDITION_COOKIE_OPTIONS
} from './constants';

// import LazyLoad from 'lazyload';

const
  {Cookies, is} = Voonto,
  app = Voonto.getInstance(),
  _header$ = $(HEADER_SELECTOR)
;

$(document).ready(function() {
  _showBreakingNewsIfProceed();
  _initEdition();

  _initPlugins($(this));
  app.on('voonto:reload', function (event, context$) {_initPlugins(context$);});

  setTimeout(function() {
    $('[data-voc-adver-unfix]').adverUnfix({offset_top: _getHeaderHeight()});
    $('[data-voc-animated-underline]').animatedUnderline();
    $('[data-voc-arrows-display]').arrowsDisplay({hideOverlapClass: '.swiper-container'});
    $('[data-voc-close-gallery]').closeGallery();
    $('body').collapseBootstrapMenus();
    $('[data-voc-dynamic-grid]').dynamicGrid();
    $('[data-voc-edition-jumper]').editionJumper();
    $('[data-voc-goto-home-bubble]').gotoHomeBubble();
    $('[data-voc-infinite-scroll]').infiniteScroll();
    $('[data-voc-scroll-progress]').scrollProgress();
    $('[data-voc-social-sharer]').socialSharer();
    $('[data-voc-bind-tab]').tabBind();

    $('#tickers-breaking-news').on('closed.bs.alert', _closeBreakingNews);
    $('[data-voc-vam]').on('vam:isempty vam:inactive',  function() {
      $(this).parent().addClass('voc-no-margins');
      $(this).remove();
    });

    //Recalculate height of every adv sticky parent when an adv is rendered.
    $('[data-voc-vam]').on('vam:viewable', function() {
       setTimeout(function() {
        $(document.body).trigger('sticky_kit:recalc');
      }, 500);
    });

    $('.voc-content-menu').on('scroll', ({originalEvent}) => originalEvent.stopPropagation());
    $('[data-target="#searchBar"]').on('click', function() {
      setTimeout(function() {
        $('#searchBar').find('input:first').focus();
      }, 0);
    });

    app.load('//platform.twitter.com/widgets.js');
    app.load('//platform.instagram.com/en_US/embeds.js');
  }, 0);
});

/* Private */

function _initPlugins(context$) {
  if (is.desktop()) {
    $('.voc-blogs.voc-beach-info', context$).find('.swiper-container').removeAttr('data-voc-carousel-auto').removeClass('swiper-container');
    $('.voc-blogs.voc-beach-info', context$).find('.swiper-wrapper').removeClass('swiper-wrapper');
    $('.voc-blogs.voc-ski-info', context$).find('.swiper-container').removeAttr('data-voc-carousel-auto').removeClass('swiper-container');
    $('.voc-blogs.voc-ski-info', context$).find('.swiper-wrapper').removeClass('swiper-wrapper');
  }

  setTimeout(function() {
    $('[data-voc-adver-displacement]').adverDisplacement({offset_top: _getHeaderHeight()});
    $('[data-voc-anchor-displacement]', context$).anchorDisplacement();
    $('[data-voc-btn-displacement]', context$).buttonDisplacement();
    $('[data-voc-carousel]', context$).carousel(SWIPER_DEFAULTS);
    $('[data-voc-carousel-fraction]', context$).carousel(SWIPER_FRACTION);
    $('[data-voc-carousel-auto]', context$).carousel(SWIPER_AUTO);
    $('[data-voc-carousel-2rows]', context$).carousel(SWIPER_2ROWS);
    $('[data-voc-carousel-adv]', context$).carousel(SWIPER_ADV);
    $('[data-voc-carousel-nav]', context$).carousel(SWIPER_NAV);
    $('[data-voc-carousel-on-plus]', context$).carousel(SWIPER_ON_PLUS);
    $('[data-voc-datepicker]', context$).datepicker();
    $('[data-voc-deactivate-tabs-onclick]', context$).deactivateTabsOnclick();
    $('[data-voc-deactivate-tabs-resolution]', context$).deactivateTabsResolution();
    $('[data-voc-dependent-select]', context$).dependentSelect();
    $('.voc-styled-select', context$).dynamicArrow();
    $('[data-voc-dynamic-grid]', context$).dynamicGrid();
    $('[data-voc-fixed-column]', context$).fixedColumn();
    $('[data-voc-init-swiper-on-tab]', context$).initSwiperOnTab();
    $('.lazy', context$).lazy();
    $('[data-voc-match-field]', context$).matchbind();
    $('[data-voc-molinillo]', context$).molinillo();
    $('[data-voc-select-display]', context$).selectDisplay();
    $('[data-voc-select-redirect]', context$).selectRedirect();
    $('[data-voc-share-selection]', context$).shareSelection({ offset_top: _getHeaderHeight() });
    $('[data-voc-social-more]', context$).socialMore();
    $('[data-voc-social-sharer]', context$).socialSharer();
    $('[data-voc-bind-tab]', context$).tabBind();
    $('[data-voc-toggle-click]', context$).toggleClick();
    $('.hemeroteca-filter', context$).on('click', (e) => $(e.target).toggleClass('active'));
    $('[data-voc-vam]', context$).on('vam:isempty vam:inactive', function () {
      $(this).parent().addClass('voc-no-margins');
      $(this).remove();
    });

    // Newsletters popups and stickies
    $('[data-voc-newsletters]', context$).newslettersStickyPopups();
  }, 0);

}

function _initEdition() {
  const editions = Voonto.getInstance().lookup('vocento.site.editions');

  if (editions.hasEditions && !Cookies.get(EDITION_COOKIE)) {
    Cookies.set(EDITION_COOKIE, editions.current, EDITION_COOKIE_OPTIONS);
  }
}

function _closeBreakingNews() {
  _header$.removeClass('voc-header-sticker');

  if ('sessionStorage' in window) {
    window.sessionStorage.setItem('bc-closed', true);
  }
}

function _showBreakingNewsIfProceed() {
  const _bn$ = $('#tickers-breaking-news');

  if (_bn$.length) {
    if ('sessionStorage' in window) {
      if (window.sessionStorage.getItem('bc-closed')) {
        _header$.removeClass('voc-header-sticker');
        _bn$.remove();
      } else {
        _bn$.addClass('voc-tickers').show();
        _header$.addClass('voc-header-sticker');
      }
    } else {
      _header$.addClass('voc-header-sticker');
      _bn$.addClass('voc-tickers').show();
    }
  } else {
    _header$.removeClass('voc-header-sticker');
    _bn$.remove();
  }

  if (document.location.pathname === '/' && _header$.hasClass('voc-header-sticker')) {
    _header$.addClass('voc-header-sticker-home');
  }
}

export function _getHeaderHeight() {
  var totalHeight = 0;

  _header$.children(':visible').each(function() {
    if (!$(this).hasClass('voc-header-home')) {
      totalHeight += $(this).outerHeight();
    }
  });

  return totalHeight;
}



// WEBPACK FOOTER //
// ./src/autoload.js